export default __webpack_public_path__ + "static/media/icons8-unit-100.6411219f.svg";